import Dot from './Dot';
import Default from './Default';

const LiveBadge = {
  Dot,
  Default,
};

export default LiveBadge;
